<template>
  <div> 
    <Table stripe :columns="columns" :data="dataInfo.recordInfoList" style="width:1500px;"></Table>
    <div style="margin: 10px;overflow: hidden">
        <Page show-sizer placement="top" :total="dataInfo.listCount" :current="dataInfo.listPage" @on-page-size-change="changePageSize" @on-change="changePage"></Page>
    </div>
  </div>
</template>
<script>
import Moment from 'moment'

  export default {
    props:['dataInfo'],
    data () {
      return {
        columns: [
          {
              title: 'ID',
              key: 'id',
              align:'center',
              width: 220 
          },
          {
              title: '管家手机号码',
              key: 'account',
              align:'center',
              width: 220
          },
          {
              title: '修改项目',
              key: 'modifyField',
              align:'center',
              width: 220
          },
          {
              title: '原设置',
              key: 'originValue',
              align:'center',
              width: 220
          },
          {
              title: '新设置',
              key: 'newValue',
              align:'center',
              width: 220
          },
          {
              title: '修改时间',
              key: 'createDate',
              align:'center',
              width: 223,
              render: (h, params) => {
                const text = Moment(params.row.createDate).format('YYYY-MM-DD HH:mm:ss');
                return h("Span",{},text);
              },
          },
          {
              title: '修改人员',
              key: 'createName',
              align:'center',
              width: 220
          }
        ],
      }
    },
    methods:{
      changePageSize (pageSize) {
        this.$emit('changePageSize', {
          size: pageSize,
          page: 1
        })
      },
      changePage (pageIndex) {
        this.$emit('changePage', {
          page: pageIndex
        })
      },
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/cleaner/housekeeper-account-edit/operation-record.vue